import { render, staticRenderFns } from "./SocialRegister.vue?vue&type=template&id=a1cb5732&scoped=true&"
import script from "./SocialRegister.vue?vue&type=script&lang=js&"
export * from "./SocialRegister.vue?vue&type=script&lang=js&"
import style0 from "./SocialRegister.vue?vue&type=style&index=0&id=a1cb5732&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cb5732",
  null
  
)

export default component.exports